// extracted by mini-css-extract-plugin
export var cardIcon = "_9i-5";
export var checkboxCard = "_9i-0";
export var checkboxCardSelected = "_9i-4";
export var disabled = "_9i-2";
export var interactive = "_9i-1";
export var outerBorder = "_9i-3";
export var spacerMedium = "_9i-8";
export var spacerSmall = "_9i-7";
export var spacerXsmall = "_9i-6";